import { Controller } from "@hotwired/stimulus";

type SignageData = {
  name: string;
  interval: number;
  url: string;
};

export default class extends Controller {
  static targets = ["title"];

  declare readonly titleTarget: HTMLElement;

  connect(): void {}

  slideChanged(event: CustomEvent<{ slide_index: number; slide: SignageData }>) {
    const slide = event.detail.slide;
    this.titleTarget.textContent = slide?.name ?? "";
  }
}
